import React from 'react';
import { entries } from 'lodash';
import { DropdownMenu, TextButton } from 'seagull';
const AddFilter = _ref => {
  let {
    filtersMap,
    selectedFilters,
    testId,
    onSelect
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": "".concat(testId, "-add-filter-container")
  }, /*#__PURE__*/React.createElement(DropdownMenu, {
    "data-testid": "".concat(testId, "-filter-picker"),
    hAlign: "center",
    target: /*#__PURE__*/React.createElement(TextButton, {
      "data-testid": "".concat(testId, "-add-filter-button"),
      underline: "hover"
    }, "+Add filter")
  }, entries(filtersMap).map(_ref2 => {
    let [type, label] = _ref2;
    return /*#__PURE__*/React.createElement(DropdownMenu.Item, {
      key: type,
      skin: "primary",
      "data-testid": "".concat(testId, "-filter-picker-").concat(type),
      disabled: selectedFilters.includes(type),
      onClick: () => onSelect(type)
    }, label);
  })));
};
export default AddFilter;